import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const RoleIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [rolePageIndex, setRolePageIndex] = useState(1);
    const [rolePageSize, setRolePageSize] = useState(store.main.pageSize);
    const [roleIdList, setRoleIdList] = useState([]);
    const [roleTotal, setRoleTotal] = useState(0);
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/role/index"});

            handleSearchRole();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadRole(rolePageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadRole(rolePageIndex, rolePageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchRole = () => {
        handleLoadRole(1, rolePageSize);
    };

    const handleLoadRole = (rolePageIndex, rolePageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = rolePageIndex;
        data.pageSize = rolePageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/role/business/website/v1/list",
            data: data,
            success: (response) => {
                setRolePageIndex(rolePageIndex);
                setRolePageSize(rolePageSize);
                setRoleIdList([]);
                setRoleTotal(response.data.total);
                setRoleList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddRole = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/role/add",
        });
    };

    const handleEditRole = (roleId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/role/edit/" + roleId,
        });
    };

    const handleDelRole = () => {
        if (roleIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/role/business/website/v1/delete",
                    data: {
                        roleIdList: roleIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setRoleIdList([]);

                        handleLoadRole(rolePageIndex, rolePageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeRoleIdList = (roleIdList) => {
        setRoleIdList(roleIdList);
    };

    const handleChangeRolePagination = (rolePageIndex, rolePageSize) => {
        handleLoadRole(rolePageIndex, rolePageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddRole}>
                                新增
                            </Button>
                            <Button loading={isLoad} disabled={roleIdList.length == 0} icon={<DeleteOutlined />} size="large" onClick={handleDelRole}>
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchRole}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="角色名称"
                                labelAlign={"left"}
                                name="roleName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入角色名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入角色名称" onPressEnter={handleSearchRole} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.roleId}
                        columns={[
                            {
                                title: "角色名称",
                                dataIndex: "roleName",
                            },
                            {
                                title: "角色类型",
                                dataIndex: "roleTypeValue",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditRole(record.roleId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={roleList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: roleIdList,
                            onChange: handleChangeRoleIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: rolePageIndex,
                            pageSize: rolePageSize,
                            total: roleTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeRolePagination,
                            onShowSizeChange: handleChangeRolePagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

RoleIndex.propTypes = {};

RoleIndex.defaultProps = {};

export default RoleIndex;
